<div id="representative-item-root" class="representative-area">
  <div class="representative-data">
    <img *ngIf="generalizedRepresentative.picture" src="{{generalizedRepresentative.picture}}" alt="{{ labels.alt }}">
    <mat-icon *ngIf="!generalizedRepresentative.picture" [ngClass]="{'representative-photo': true, 'error': isExpired()}"
              [title]="getAlt()">person</mat-icon>
    <div class="info-data">
      <div class="title">
        <p class="name">{{ getTitle() }}</p>
        <p class="title-admin" *ngIf="isAdmin()">{{ labels.adminTag }}</p>
      </div>
      <p class="email"
         title="{{generalizedRepresentative.email}}">
        <a href="mailto:{{generalizedRepresentative.email}}">
          {{ generalizedRepresentative.email }}
        </a>
      </p>
    </div>
  </div>
  <div *ngIf="!isAdmin() && canTamper" class="icons-area">
    <ng-container [ngSwitch]="isRepresentative()">
      <div *ngSwitchCase="true"
           (click)="doPromote()"
           class="clickable-area"
           title="{{representativeItemLabels.promoteRep}}">
        <span class="label-small">{{ representativeItemLabels.promoteRep }}</span>
        <div class="icon">
          <app-circle id="lnr-representative-promote" size="xsmall" innerShadow>account_box</app-circle>
        </div>
      </div>
      <div *ngSwitchCase="false"
           (click)="doResendInvite()"
           class="clickable-area"
           title="{{representativeItemLabels.resendInvite}}">
        <span class="label-small">{{ representativeItemLabels.resendInvite }}</span>
        <div class="icon">
          <app-circle id="lnr-resend-invite" size="xsmall" innerShadow>schedule</app-circle>
        </div>
      </div>
    </ng-container>
    <div (click)="doRemove()"
         class="clickable-area"
         title="{{representativeItemLabels.deleteRep}}">
      <span class="label-small">{{ representativeItemLabels.deleteRep }}</span>
      <div class="icon"
           title="{{representativeItemLabels.deleteRep}}">
        <app-circle id="lnr-representative-delete" size="xsmall" innerShadow>delete</app-circle>
      </div>
    </div>
  </div>
</div>
